import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../BaseModule/Components/BaseModal/BaseModal';
// @ts-ignore
import styles from './BMIMeasurementItemHintModal.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';

const BMIMeasurementItemHintModal: React.FC<BaseModalProps> = props => {
	const { t } = useTranslation();

	return (
		<BaseModal title='BMI' {...props}>
			<div className={styles.wrapper}>
				<div className={styles.item}>
					<img src='http://cdn.meddi.com/meddiApp-assets/wizard/BMI/smile-blue.png' />
					<div>
						<span>
							{t('component.BMIMeasurementHistoryItemHeader.underweight.title')}
							:
						</span>{' '}
						{t(
							'component.BMIMeasurementHistoryItemHeader.underweight.specification',
						)}
					</div>
				</div>
				<div className={styles.item}>
					<img src='http://cdn.meddi.com/meddiApp-assets/wizard/BMI/smile-green.png' />
					<div>
						<span>
							{t(
								'component.BMIMeasurementHistoryItemHeader.normalWeight.title',
							)}
							:
						</span>{' '}
						{t(
							'component.BMIMeasurementHistoryItemHeader.normalWeight.specification',
						)}
					</div>
				</div>
				<div className={styles.item}>
					<img src='http://cdn.meddi.com/meddiApp-assets/wizard/BMI/smile-yellow.png' />
					<div>
						<span>
							{t('component.BMIMeasurementHistoryItemHeader.overweight.title')}:
						</span>{' '}
						{t(
							'component.BMIMeasurementHistoryItemHeader.overweight.specification',
						)}
					</div>
				</div>
				<div className={styles.item}>
					<img src='http://cdn.meddi.com/meddiApp-assets/wizard/BMI/smile-orange.png' />
					<div>
						<span>
							{t('component.BMIMeasurementHistoryItemHeader.obesity.title')}:
						</span>{' '}
						{t(
							'component.BMIMeasurementHistoryItemHeader.obesity.specification',
						)}
					</div>
				</div>
				<div className={styles.item}>
					<img src='http://cdn.meddi.com/meddiApp-assets/wizard/BMI/smile-red.png' />
					<div>
						<span>
							{t(
								'component.BMIMeasurementHistoryItemHeader.extremeObesity.title',
							)}
							:
						</span>{' '}
						{t(
							'component.BMIMeasurementHistoryItemHeader.extremeObesity.specification',
						)}
					</div>
				</div>
			</div>
		</BaseModal>
	);
};

export default BMIMeasurementItemHintModal;
